export enum ReportFormatEnum {
  XLSX = 'xlsx',
  PDF = 'pdf',
}
